import useLang from "./../../../../Shared/hooks/useLanguage";

const StewardReportInfo = [
    "Lab Name",
    "Panel Name",
    "Medication List",
    "Ordering Provider",
    "Test Name",
];

const StewardReport = () => {
    const { t } = useLang();

    const renderCheckboxes = (labels: string[], startIndex: number) =>
        labels.map((label, index) => {
            const uniqueId = `checkbox-${label.replace(/\s+/g, "-").toLowerCase()}-${index + startIndex
                }`;

            return (
                <div className="col-lg-2 col-md-3 col-sm-4 col-xs-6" key={uniqueId}>
                    <div className="mb-7">
                        <label
                            className="form-check form-check-sm form-check-solid"
                            htmlFor={uniqueId}
                        >
                            {t(label)}
                        </label>
                    </div>
                </div>
            );
        });

    return (
        <>
            <div className="row mt-10">{renderCheckboxes(StewardReportInfo, 0)}</div>
        </>
    );
};

export default StewardReport;
